"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _props = _interopRequireDefault(require("./props.scss"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var padLeft = function padLeft(depth) {
  return {
    paddingLeft: "".concat(depth * 20, "px")
  };
};

var oneOfVal = function oneOfVal(val) {
  return typeof val === 'string' ? "'".concat(val, "'") : "".concat(val);
};

var oneOfTypeVal = function oneOfTypeVal(type) {
  return type.name;
};

var metaArr = function metaArr(arr, fn) {
  return "[".concat(arr.map(fn).join(', '), "]");
};

var ColName = function ColName(_ref) {
  var children = _ref.children,
      _ref$depth = _ref.depth,
      depth = _ref$depth === void 0 ? 0 : _ref$depth;
  return _react["default"].createElement("td", {
    className: _props["default"]['name'],
    style: padLeft(depth)
  }, children);
};

var ColType = function ColType(_ref2) {
  var type = _ref2.type;
  return _react["default"].createElement("td", {
    className: _props["default"]['type']
  }, type.name);
};

var ColRequired = function ColRequired(_ref3) {
  var required = _ref3.required;
  return _react["default"].createElement("td", {
    className: _props["default"]['required']
  }, required ? 'true' : 'false');
};

var ColDefault = function ColDefault(_ref4) {
  var defaultValue = _ref4["default"];
  var renderedVal = '';

  if (typeof children === 'function') {
    renderedVal = defaultValue.toString();
  } else if (typeof defaultValue === 'boolean') {
    renderedVal = defaultValue ? 'true' : 'false';
  } else if (typeof defaultValue === 'string') {
    renderedVal = defaultValue ? defaultValue : "''";
  } else if (typeof defaultValue === 'number') {
    renderedVal = defaultValue;
  } else if (Array.isArray(defaultValue)) {
    renderedVal = "[".concat(defaultValue.map(oneOfVal).join(', '), "]");
  } else {
    renderedVal = JSON.stringify(defaultValue);
  }

  return _react["default"].createElement("td", {
    className: _props["default"]['default']
  }, renderedVal);
};

var ColDescription = function ColDescription(_ref5) {
  var prop = _ref5.prop;
  return _react["default"].createElement("td", {
    className: _props["default"]['description']
  }, prop.deprecated && _react["default"].createElement("div", {
    className: _props["default"]['deprecated']
  }, "[DEPRECATED] ", prop.deprecated), _react["default"].createElement("div", {
    className: _props["default"]['text']
  }, prop.description), _react["default"].createElement(Meta, {
    prop: prop
  }));
};

var BaseColumns = function BaseColumns(_ref6) {
  var name = _ref6.name,
      prop = _ref6.prop,
      _ref6$depth = _ref6.depth,
      depth = _ref6$depth === void 0 ? 0 : _ref6$depth;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement(ColName, {
    depth: depth
  }, name), _react["default"].createElement(ColType, prop), _react["default"].createElement(ColRequired, prop), _react["default"].createElement(ColDefault, prop));
};

var Meta = function Meta(_ref7) {
  var prop = _ref7.prop;
  var meta = '';

  if (prop.type.name === 'oneOf') {
    meta = "oneOf: ".concat(metaArr(prop.type.arr, oneOfVal));
  } else if (prop.type.name === 'oneOfType') {
    meta = "oneOf: ".concat(metaArr(prop.type.types, oneOfTypeVal));
  } else if (prop.type.name === 'arrayOf') {
    meta = "arrayOf: [".concat(prop.type.type.name, "]");
  } else if (prop.type.name === 'objectOf') {
    meta = "objectOf: ".concat([prop.type.type.name]);
  }

  return meta && _react["default"].createElement("div", {
    className: _props["default"]['meta']
  }, meta);
};

var ShapeRow = function ShapeRow(_ref8) {
  var name = _ref8.name,
      prop = _ref8.prop,
      _ref8$depth = _ref8.depth,
      depth = _ref8$depth === void 0 ? 0 : _ref8$depth;
  return _react["default"].createElement(_react["default"].Fragment, null, _react["default"].createElement("tr", null, _react["default"].createElement(BaseColumns, {
    name: name,
    prop: prop,
    depth: depth
  })), Object.keys(prop.props).map(function (name, i) {
    return _react["default"].createElement(Row, {
      key: i,
      depth: depth + 1,
      name: name,
      prop: prop.props[name]
    });
  }));
};

var Row = function Row(_ref9) {
  var name = _ref9.name,
      prop = _ref9.prop,
      _ref9$depth = _ref9.depth,
      depth = _ref9$depth === void 0 ? 0 : _ref9$depth;
  return prop.type.name === 'shape' ? _react["default"].createElement(ShapeRow, {
    name: name,
    prop: prop,
    depth: depth
  }) : _react["default"].createElement("tr", null, _react["default"].createElement(BaseColumns, {
    name: name,
    prop: prop,
    depth: depth
  }), _react["default"].createElement(ColDescription, {
    prop: prop
  }));
};

var Props = function Props(_ref10) {
  var props = _ref10.props;
  return _react["default"].createElement("div", {
    className: _props["default"]['props']
  }, _react["default"].createElement("table", null, _react["default"].createElement("thead", null, _react["default"].createElement("tr", null, _react["default"].createElement("th", null, "Name"), _react["default"].createElement("th", null, "Type"), _react["default"].createElement("th", null, "Required"), _react["default"].createElement("th", null, "Default"), _react["default"].createElement("th", null, "Description"))), _react["default"].createElement("tbody", null, Object.keys(props).map(function (name, i) {
    return _react["default"].createElement(Row, {
      key: i,
      name: name,
      prop: props[name]
    });
  }))));
};

Props.propTypes = {
  component: _propTypes["default"].string,
  props: _propTypes["default"].object
};
Props.defaultProps = {
  component: '',
  props: {}
};
var _default = Props;
exports["default"] = _default;